import React from 'react';
import ReactDOM from 'react-dom/client';
import LegalStandalonePage from './LegalStandalonePage.jsx';
import '../index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LegalStandalonePage doc="privacy" />
  </React.StrictMode>
);
